import {
  Box,
  Button,
  CardMedia,
  Dialog,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { Formik, setNestedObjectValues } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  verifyPan,
  EnablePOA,
  IsApplicableForPOA,
  SendEmail,
  AcknowledgeAmlCheck,
  getApplicationToken,
  sendConsentEmail,
  SendDigio,
} from '../../redux-store/actions/onBoarding';
import {
  AcknowledgeAmlCheckResponseBody,
  AmlSystemMatch,
  ApplicationProps,
  EnablePOAResponseBody,
  IsApplicableForPOAResponseBody,
  SendConsentEmailResponseBody,
  SendDigioResponse,
  SendOtpResponseBody,
  VerifyOtpResponseBody,
  VerifyPanResponseBody,
} from '../../redux-store/types/api-types';
import CloseIcon from '@mui/icons-material/Close';
import { addJointHolder, createApplication } from '../../redux-store/actions/application';
import {
  emailRegex,
  individualPanRegex,
  nonDigitRegex,
  nonIndividualPanRegex,
  numberRegex,
  phoneRegExp,
} from '../../utils/regex';
import { Location } from 'history';
import { Notes } from '../investors/components';
import MFCheckbox from '../../lib/formik/Checkbox';
import {
  futureAge,
  getCountryCodes,
  isMinor,
  maxAge,
  openUrl,
  preventSpecialCharacters,
} from '../../utils/utilityFunctions';
import {
  AML_ALL_DISPLAY_MODE,
  APPLICATION_TYPE,
  ENABLE_Email_Consent,
  ENABLE_EMAIL_OTP,
  IS_DOB_APPLICABLE_FOR_AMC,
  KRA_STATUS_MASTER,
  ONBOARDING_OPTIONS,
  USER_ROLES,
} from '../../utils/constant';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import SimpleDialog, { AmlPopup, AmlPopupValues, CountryCodesDropDown } from '../commonComponents';
import { Link as RouterLink } from 'react-router-dom';
import UseRadioGroup from '../../lib/formik/Radio';
import { useSnackbar } from 'notistack';
import { RootStateType } from '../../redux-store/reducers';
import { TextDatePicker } from '../../lib/formik/DatePickerWithTextFeild';
import MFSelectField from '../../lib/formik/SelectField';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LinkIcon from '@mui/icons-material/Link';
import { red } from '@mui/material/colors';
import { useModal } from 'mui-modal-provider';
import { KRAAlertDialog } from './KycDialog';
interface Values {
  pan: string;
  dob: string | null;
}

interface MValues {
  pan: string;
  mobile?: string;
  bypassOtp: boolean;
  skipOtpModal: boolean;
  emailId: string;
  hasPOA: boolean;
  dob: string | null;
  countryCode: string;
  countryNameAndCode: string;
  onboardingOtpEmailConsent?: string;
  kraStatus: string;
}
interface EValues {
  pan: string;
  emailId: string;
  dob: string;
  kraStatus: string;
}

export default function EnterPAN({
  location,
}: {
  location: Location<{
    firstHolderName: string;
    application: ApplicationProps;
    redirectTo: string;
  }>;
}): JSX.Element {
  const { redirectTo = '', firstHolderName = '', application } = location.state || {};
  const { id, applicants = [], hasPOA } = application || {};
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [amlPopup, setAmlPopup] = React.useState<{
    panVerificationToken: string;
    pan: string;
    dob: string | null;
  } | null>(null);
  const [amlFailedresponse, setAmlFailedresponse] = React.useState<AmlSystemMatch>();
  const [amlAcknowledgementLoading, setAmlAcknowledgementLoading] = React.useState(false);

  const applicantPanNumbers = applicants.map((applicant) => applicant.panNo);
  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P') {
          if (!individualPanRegex.test(fieldValue))
            return createError({
              message: 'Invalid PAN',
              path,
            });
          if (individualPanRegex.test(fieldValue)) return true;
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P' && applicantPanNumbers.includes(fieldValue)) {
          return createError({
            message: 'There is already same pan for an applicant associated with this application',
            path,
          });
        }
        return true;
      }),
    dob: yup
      .string()
      .nullable()
      .test('dob', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError, parent } = context;
        if (IS_DOB_APPLICABLE_FOR_AMC) {
          if (!fieldValue) {
            return createError({
              message: 'Date of birth is required',
              path,
            });
          } else if (
            futureAge(fieldValue) ||
            fieldValue.toString().toLowerCase() === 'invalid date'
          ) {
            return createError({
              message: 'Invalid Date',
              path,
            });
          } else if (isMinor(fieldValue) && parent.pan?.split('')[3] === 'P') {
            return createError({
              message: 'Age should be greater than 18',
              path,
            });
          } else if (maxAge(fieldValue) && parent.pan?.split('')[3] === 'P') {
            return createError({
              message: 'Age should be less than 125',
              path,
            });
          }
        }

        return true;
      }),
  });
  const initialValues1: Values = { pan: '', dob: '' };
  const routingAfterPanVerification = async (
    response: VerifyPanResponseBody | AcknowledgeAmlCheckResponseBody,
    pan: string,
    dob: string | null
  ) => {
    if (hasPOA) {
      const { panVerificationToken } = response || {};
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await dispatch(addJointHolder({ applicantVerificationToken }, id));
      history.push(redirectTo, { id });
      return;
    }
    if (response.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) {
      return history.push('enter-email-id', {
        pan: pan.toUpperCase(),
        dob: dob,
        ...(response || {}),
      });
    }
    history.push('enter-mobile-number', {
      pan: pan.toUpperCase(),
      dob: dob,
      ...(response || {}),
      redirectTo,
      firstHolderName,
      application,
      // kraStatus: 'not_kyc', // Defaulting to not_kyc, actual status will be determined in EnterMobile component
    });
  };

  const handleSubmit1 = async (values: Values) => {
    try {
      const { pan, dob } = values;
      const response = (await dispatch(
        verifyPan({ pan, dob })
      )) as unknown as VerifyPanResponseBody;
      if (!response.amlCheck) {
        const { system_match = [], referral_match = [] } = response.amlData || {};
        const matches = AML_ALL_DISPLAY_MODE
          ? [...system_match, ...referral_match]
          : [system_match[0] || referral_match[0]].filter(Boolean);
        setAmlFailedresponse(
          matches.length
            ? {
                ...matches[0],
                FURTHER_INFORMATION: matches
                  .map((m) => m.FURTHER_INFORMATION)
                  .filter(Boolean)
                  .join('\n\n'),
                EXTERNAL_SOURCES: matches
                  .map((m) => m.EXTERNAL_SOURCES)
                  .filter(Boolean)
                  .join('\n'),
              }
            : undefined
        );
        return setAmlPopup({
          panVerificationToken: response.panVerificationToken,
          pan: pan,
          dob: dob,
        });
      }
      routingAfterPanVerification(response, pan, dob);
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  const handleClose = () => {
    setAmlPopup(null);
  };

  const onSubmit = async (values: AmlPopupValues) => {
    try {
      setAmlAcknowledgementLoading(true);
      const { amlComments, amlAcknowledgement } = values;
      const { panVerificationToken = '', pan = '', dob = '' } = amlPopup || {};
      setAmlPopup(null);
      const response = (await dispatch(
        AcknowledgeAmlCheck({ panVerificationToken, amlComments, amlAcknowledgement })
      )) as unknown as AcknowledgeAmlCheckResponseBody;
      routingAfterPanVerification(response, pan, dob);
    } catch (e) {
      console.error((e as Error).message);
    }
  };
  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, resetForm }) => (
          <>
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <MFTextField
                label="PAN"
                name="pan"
                placeholder="Enter PAN"
                required
                autoComplete="off"
                inputProps={{ style: { textTransform: 'uppercase' } }}
              />
              {IS_DOB_APPLICABLE_FOR_AMC && (
                <TextDatePicker
                  minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                  label={'Date of Birth/Incorporation'}
                  inputLabelStyles={{
                    transform: 'unset',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'rgba(0,0,0,0.7)',
                  }}
                  placeholder={'DD/MM/YYYY'}
                  name="dob"
                />
              )}

              <MFSubmitButton label="Verify PAN" loadingEnable={amlAcknowledgementLoading} />
              <Notes
                displayContent={
                  'Add the applicant(s) PAN and if the PAN is KRA verified, the contact details will be populated automatically. Pan will be checked against World-Check database for AML compliance.'
                }
              />
            </Box>
            <Dialog open={open} onClose={() => setOpen(false)}>
              <Box
                sx={{
                  p: { xs: 2, sm: 8 },
                  borderRadius: '10px',
                  // width: { xs: '70%', sm: '70%' },
                  maxWidth: 800,
                  height: { xs: '90%', md: 'unset' },
                  overflowY: 'auto',
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '& .MuiButton-root': {
                      minWidth: 200,
                      fontSize: 16,
                    },
                  }}>
                  <Box sx={{ mb: 8 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      color: '#337FC9',
                      textAlign: 'center',
                      width: '70%',
                      mb: 5,
                    }}>
                    Unable to verify the details please contact admin
                  </Typography>
                  <Button
                    // component={RouterLink}
                    variant="contained"
                    onClick={() => {
                      resetForm();
                      setOpen(false);
                    }}
                    sx={{ color: 'common.white' }}>
                    Enter another PAN
                  </Button>
                </Box>
              </Box>
            </Dialog>
            <AmlPopup
              handleClose={handleClose}
              amlPopupOpen={amlPopup !== null}
              onSubmit={onSubmit}
              FURTHER_INFORMATION={amlFailedresponse?.FURTHER_INFORMATION}
              EXTERNAL_SOURCES={amlFailedresponse?.EXTERNAL_SOURCES}
              displayDocInfo={true}
            />
          </>
        )}
      </Formik>
    </>
  );
}
export function EnterMobile({
  location,
}: {
  location: Location<{
    redirectTo: string;
    panVerificationToken: string;
    pan: string;
    firstHolderName: string;
    application: ApplicationProps;
    dob: string;
    kraStatus: string;
    digioId: string;
    phone?: string;
    emailId?: string;
  }>;
}): JSX.Element {
  const {
    redirectTo = '',
    panVerificationToken,
    pan,
    firstHolderName = '',
    application,
    dob,
    kraStatus,
    digioId = '',
    phone = '',
    emailId = '',
  } = location.state || {};
  const { id, applicants = [] } = application || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const [disablePOA, setDisablePOA] = useState(false);
  // eslint-disable-next-line
  const applicantMobileNumbers = applicants.map((applicant) => applicant.mobile);
  const { enqueueSnackbar } = useSnackbar();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const { showModal } = useModal();
  const [kraDialogOpen, setKraDialogOpen] = useState(false);
  const [kraDetailsCaptured, setKraDetailsCaptured] = useState(false);
  const [digioResponse, setDigioResponse] = useState<SendDigioResponse>();

  // 🔥 Open dialog immediately on page load
  useEffect(() => {
    if (['kraonhold', 'not_kyc', 'kraregistered'].includes(kraStatus) && digioId) {
      setKraDialogOpen(true);
    }
  }, [kraStatus]);

  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P') {
          if (!individualPanRegex.test(fieldValue))
            return createError({
              message: 'Invalid PAN',
              path,
            });
          if (individualPanRegex.test(fieldValue)) return true;
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        return true;
      }),
    emailId: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value) && ENABLE_EMAIL_OTP,
      then: yup.string().test('emailId', (value, context) => {
        const { createError, path } = context;
        if (!value) {
          return createError({
            message: 'Email Id is required',
            path,
          });
        }
        if (!emailRegex.test(value)) {
          return createError({
            message: 'Invalid Email Id',
            path,
          });
        }
        return true;
      }),
    }),

    mobile: yup.string().when('hasPOA', {
      is: (value: boolean) => (disablePOA ? true : !value),
      then: yup.string().test('mobile', (value, context) => {
        const { createError, path, parent } = context;
        const codesList = getCountryCodes()
          .map((codes) => {
            if (codes.label === parent.countryNameAndCode) {
              return codes.countryCode;
            }
          })
          .filter((ele) => ele)
          .toString();
        if (!value) {
          return createError({
            message: 'Mobile number is required',
            path,
          });
        }
        if (parent.countryNameAndCode === 'India: +91' && !phoneRegExp.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!numberRegex.test(value)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        if (!isValidPhoneNumber(value, codesList as CountryCode)) {
          return createError({
            message: 'Invalid Mobile number',
            path,
          });
        }
        // if (applicantMobileNumbers.includes(value)) {
        //   return createError({
        //     message:
        //       'There is already same mobile number for an applicant associated with this application',
        //     path,
        //   });
        // }
        return true;
      }),
    }),
    countryNameAndCode: yup
      .string()
      .nullable()
      .when('hasPOA', {
        is: (value: boolean) => (disablePOA ? true : !value),
        then: yup.string().test('countryNameAndCode', (value, context) => {
          const { createError, path, parent } = context;
          const codesList = getCountryCodes()
            .map((codes) => {
              if (codes.label === value) {
                return codes.countryCode;
              }
            })
            .filter((ele) => ele)
            .toString();
          if (!value) {
            return createError({
              message: 'Country Code is required',
              path,
            });
          }
          if (parent.mobile && !numberRegex.test(parent.mobile)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }
          if (parent.mobile && !isValidPhoneNumber(parent.mobile, codesList as CountryCode)) {
            return createError({
              message: 'Invalid Mobile number',
              path,
            });
          }

          return true;
        }),
      }),
  });
  const initialValues1: MValues = {
    pan: pan,
    mobile: phone ?? '',
    emailId: emailId ?? '',
    bypassOtp: false,
    skipOtpModal: false,
    hasPOA: false,
    dob: dob,
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    onboardingOtpEmailConsent: 'otp',
    kraStatus: kraStatus,
  };

  const handleCreateApplication = async (applicantVerificationToken: string) => {
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/application/distributor-details', { ...(res || {}) });
  };

  const handleSubmit1 = async (values: MValues) => {
    const {
      mobile = '',
      hasPOA,
      emailId,
      countryNameAndCode = 'India: +91',
      onboardingOtpEmailConsent = 'otp',
    } = values;
    // if (typeof digioResponse?.blockJourney === 'string' && digioResponse?.blockJourney === 'true') {
    //   const { destroy } = showModal(SimpleDialog, {
    //     content: 'Your KYC is currently on hold. Please contact support for further assistance.',
    //     actions: [
    //       {
    //         label: 'OK',
    //         onClick: () => {
    //           destroy();
    //         },
    //       },
    //     ],
    //   });
    //   return;
    // }
    if (hasPOA) {
      const poaResponse = (await dispatch(
        EnablePOA({ panVerificationToken, powerOfAttorney: true })
      )) as unknown as EnablePOAResponseBody;
      const { applicantVerificationToken } = poaResponse;
      await handleCreateApplication(applicantVerificationToken);
      return;
    }
    if (ONBOARDING_OPTIONS[onboardingOtpEmailConsent] === ONBOARDING_OPTIONS.email_consent) {
      (await dispatch(
        sendConsentEmail({
          phoneNumber: mobile.trim(),
          emailId,
          panVerificationToken,
          countryCode: countryNameAndCode?.split(':')[1].trim(),
          countryNameAndCode,
          applicationId: id || '',
        })
      )) as unknown as SendConsentEmailResponseBody;
      enqueueSnackbar('Email sent successfully', {
        variant: 'success',
        autoHideDuration: 3000,
      });
      return history.push(
        [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
          ? `/applications-list`
          : '/applications'
      );
    }

    const response = (await dispatch(
      getApplicationToken({
        phoneNumber: mobile.trim(),
        emailId,
        panVerificationToken,
        countryCode: countryNameAndCode?.split(':')[1].trim(),
        countryNameAndCode,
        digioInfoId: digioId,
      })
    )) as unknown as VerifyOtpResponseBody;

    const { applicantVerificationToken } = response || {};
    // if (bypassOtp) {
    if (id && redirectTo) {
      (await dispatch(
        addJointHolder({ applicantVerificationToken }, id)
      )) as unknown as ApplicationProps;
      history.push(redirectTo, { id });
      return;
    }
    //   handleCreateApplication(applicantVerificationToken);
    //   return;
    // }
    await handleCreateApplication(applicantVerificationToken);
    // history.push('enter-otp', {
    //   pan,
    //   unmaskedphone: mobile.trim(),
    //   umaskedemailId: emailId,
    //   mobile: phoneNumber,
    //   panVerificationToken,
    //   redirectTo,
    //   application,
    //   email: (response || {}).emailId,
    //   firstHolderName,
    //   countryCode: countryNameAndCode?.split(':')[1].trim(),
    //   countryNameAndCode,
    //   ...(response || {}),
    // });
  };

  useEffect(() => {
    (async function () {
      const res = (await dispatch(
        IsApplicableForPOA()
      )) as unknown as IsApplicableForPOAResponseBody;
      const { powerOfAttorney } = res;
      setDisablePOA(
        application
          ? application.hasPOA
            ? application.hasPOA
            : !application.hasPOA
          : !powerOfAttorney
      );
    })();
  }, []);

  // ✅ Called when dialog form succeeds
  const handleKraDialogSuccess = async ({
    emailId,
    phone,
    digioId,
  }: {
    emailId: string;
    phone: string;
    digioId: string;
  }) => {
    const response = (await dispatch(
      SendDigio({ emailId, phone, digioId })
    )) as unknown as SendDigioResponse;
    setDigioResponse(response);
    setKraDetailsCaptured(true);
    setKraDialogOpen(false);
  };
  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, values, isSubmitting, setFieldValue }) => {
          useEffect(() => {
            if (digioResponse?.phone) {
              setFieldValue('mobile', digioResponse.phone);
            }
          }, [digioResponse?.phone]);

          return (
            <Box
              sx={
                {
                  // pointerEvents:
                  //   kraDetailsCaptured &&
                  //   !['kraonhold', 'not_kyc', 'kraregistered'].includes(kraStatus) &&
                  //   !digioId
                  //     ? 'auto'
                  //     : 'none',
                  // opacity:
                  //   kraDetailsCaptured &&
                  //   !['kraonhold', 'not_kyc', 'kraregistered'].includes(kraStatus) &&
                  //   !digioId
                  //     ? 1
                  //     : 0.5,
                }
              }>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <Box sx={{ position: 'relative' }}>
                  <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                    <CardMedia
                      component="img"
                      src="/images/tick.svg"
                      sx={{ width: '18px', float: 'right' }}
                    />
                  </Box>
                  <MFTextField
                    label="PAN"
                    name="pan"
                    placeholder="Enter PAN"
                    required
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                    disabled={true}
                  />
                  {IS_DOB_APPLICABLE_FOR_AMC && (
                    <TextDatePicker
                      minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                      label={'Date of birth'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'Enter Date of birth'}
                      name="dob"
                      disabled={true}
                    />
                  )}

                  {/* <MFCheckbox
                name="hasPOA"
                label="Power of Attorney"
                color="primary"
                sx={{
                  '.MuiTypography-root': {
                    color: 'primary.main',
                    fontWeight: 500,
                    fontSize: 14,
                    letterSpacing: '0.9625px',
                  },
                }}
                disabled={disablePOA}
              /> */}
                </Box>
                {!values.hasPOA && (
                  <>
                    <MFTextField
                      label="Mobile Number"
                      name="mobile"
                      placeholder="Enter Mobile number"
                      onKeyDown={(e) => {
                        preventSpecialCharacters(e);
                      }}
                      startAdornment={
                        <CountryCodesDropDown
                          name={'countryNameAndCode'}
                          value={values.countryNameAndCode}
                        />
                      }
                      regexForFilterValue={nonDigitRegex}
                    />
                    {ENABLE_EMAIL_OTP && (
                      <MFTextField
                        autoComplete="off"
                        // autoFocus
                        label="Email ID"
                        name="emailId"
                        placeholder="Enter Email ID"
                        required
                      />
                    )}
                    {ENABLE_Email_Consent && (
                      <UseRadioGroup
                        formLabel=""
                        name={`onboardingOtpEmailConsent`}
                        defaultValue="otp"
                        items={Object.keys(ONBOARDING_OPTIONS).map((option) => ({
                          label: ONBOARDING_OPTIONS[option],
                          value: option,
                        }))}
                      />
                    )}
                    {/* <Notes
                  displayContent={
                    'Provide the mobile phone number which is registered in KRA database. Applicants Identity details will be fetched from the KRA database.'
                  }
                /> */}
                  </>
                )}
                {kraStatus && (
                  <MFSelectField
                    name={`kraStatus`}
                    label="KRA Status *"
                    items={Object.keys(KRA_STATUS_MASTER).map((item) => ({
                      key: KRA_STATUS_MASTER[item],
                      value: item,
                    }))}
                    disabled={true}
                  />
                )}
                {digioResponse?.digioLink && (
                  <Stack
                    spacing={1}
                    sx={{
                      backgroundColor: 'rgba(51, 127, 201, 0.04)',
                      border: '1px solid rgba(51, 127, 201, 0.2)',
                      borderRadius: 2,
                      padding: 2,
                      boxSizing: 'border-box',
                    }}>
                    {/* Header */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography variant="subtitle2" fontWeight={600}>
                        KYC Completion Link (For Client)
                      </Typography>

                      <Stack direction="row" spacing={0.5}>
                        {/* Open Link */}
                        <Tooltip title="Open link in new tab">
                          <IconButton
                            size="small"
                            onClick={() => openUrl(digioResponse?.digioLink)}>
                            <OpenInNewIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* Copy Link */}
                        <Tooltip title="Copy link">
                          <IconButton
                            size="small"
                            onClick={() => navigator.clipboard.writeText(digioResponse?.digioLink)}>
                            <ContentCopyIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Stack>

                    {/* URL Display */}
                    {digioResponse?.digioLink && (
                      <Tooltip title={digioResponse?.digioLink}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          sx={{
                            backgroundColor: '#fff',
                            border: '1px dashed',
                            borderColor: 'divider',
                            borderRadius: 1,
                            px: 1.5,
                            py: 1,
                            cursor: 'default',
                          }}>
                          <Typography
                            variant="body2"
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              color: 'text.secondary',
                              width: '100%',
                            }}>
                            {digioResponse?.digioLink}
                          </Typography>
                        </Stack>
                      </Tooltip>
                    )}
                  </Stack>
                )}
                <Notes
                  displayContent={
                    'If the KYC is not validated for Resident Individual (RI) then request you to do the KYC validation at the earliest. Allotment shall be on hold for RI if KYC is not validated at the time of on-boarding'
                  }
                />
                <MFSubmitButton
                  label={
                    ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                    ONBOARDING_OPTIONS.email_consent
                      ? 'Send Email'
                      : 'Proceed'
                  }
                  disabled={digioResponse?.blockJourney === 'true'}
                />
                {/* {!values.hasPOA &&
              ONBOARDING_OPTIONS[values.onboardingOtpEmailConsent || ''] ===
                ONBOARDING_OPTIONS.otp && (
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    color: 'primary.main',
                    fontWeight: 500,
                    fontSize: 14,
                    mt: 0.5,
                    lineHeight: 1.5,
                  }}
                  onClick={async () => {
                    const error = await validateForm();
                    if (Object.keys(error).length) {
                      setTouched(setNestedObjectValues(error, true));
                      setErrors(error);
                      return;
                    }
                    setFieldValue('skipOtpModal', true);
                  }}>
                  Skip OTP Verification
                </Button>
              )} */}
                <Dialog
                  open={values.skipOtpModal}
                  onClose={() => setFieldValue('skipOtpModal', false)}>
                  <Box
                    sx={{
                      borderRadius: '10px',
                      // width: { xs: '70%', sm: '70%' },
                      maxWidth: 800,
                      height: { xs: '90%', md: 'unset' },
                      overflowY: 'auto',
                    }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 3,
                        '& .MuiButton-root': {
                          minWidth: 200,
                          fontSize: 16,
                        },
                      }}>
                      <IconButton
                        onClick={() => setFieldValue('skipOtpModal', false)}
                        sx={{ alignSelf: 'flex-end' }}>
                        <CloseIcon fontSize="small" />
                      </IconButton>
                      {/* <Box sx={{ mb: 4 }}>
                    <CardMedia
                      component="img"
                      src="/images/warning-icon-red.svg"
                      sx={{ width: 'unset' }}
                    />
                  </Box> */}
                      <Typography
                        sx={{
                          fontSize: 20,
                          fontWeight: 500,
                          color: '#337FC9',
                          textAlign: 'center',
                          mb: 5,
                          width: '90%',
                        }}>
                        Are you sure you want to Skip OTP Verification?
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          justifyContent: 'space-around',
                          width: '100%',
                        }}>
                        <Button
                          variant="outlined"
                          disabled={isSubmitting}
                          onClick={() => setFieldValue('skipOtpModal', false)}
                          sx={{ color: 'primary.main', mb: 2 }}>
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          sx={{ mb: 2 }}
                          onClick={() => {
                            setFieldValue('bypassOtp', true);
                            handleSubmit();
                          }}>
                          Continue
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                </Dialog>
              </Box>
            </Box>
          );
        }}
      </Formik>
      <KRAAlertDialog
        open={kraDialogOpen}
        initialEmail={pan ? undefined : ''}
        initialPhone={pan ? undefined : ''}
        digioId={digioId}
        onSuccess={handleKraDialogSuccess}
      />
    </>
  );
}

export function EnterEmailId({
  location,
}: {
  location: Location<{
    panVerificationToken: string;
    pan: string;
    dob: string;
    kraStatus: string;
    digioId: string;
    emailId: string;
  }>;
}): JSX.Element {
  const {
    panVerificationToken,
    pan,
    dob,
    kraStatus,
    digioId = '',
    emailId = '',
  } = location.state || {};
  const dispatch = useDispatch();
  const history = useHistory();
  const { showModal } = useModal();
  const [kraDialogOpen, setKraDialogOpen] = useState(false);
  const [kraDetailsCaptured, setKraDetailsCaptured] = useState(false);
  const [digioResponse, setDigioResponse] = useState<SendDigioResponse>();

  // 🔥 Open dialog immediately on page load
  useEffect(() => {
    // console.log('KRA Status:', kraStatus); // Debug log to check kraStatus value
    if (
      (kraStatus === 'kraonhold' || kraStatus === 'not_kyc' || kraStatus === 'kraregistered') &&
      digioId
    ) {
      setKraDialogOpen(true);
    }
  }, [kraStatus]);

  const validationSchema1 = yup.object().shape({
    pan: yup
      .string()
      .uppercase()
      .length(10, 'PAN must be exactly 10 characters')
      .test('pan', (value, context) => {
        const fieldValue = value === undefined ? '' : value;
        const { path, createError } = context;
        if (!fieldValue) {
          return createError({
            message: 'PAN is required',
            path,
          });
        }
        if (fieldValue.split('')[3] === 'P') {
          if (!individualPanRegex.test(fieldValue))
            return createError({
              message: 'Invalid PAN',
              path,
            });
          if (individualPanRegex.test(fieldValue)) return true;
        }
        if (!nonIndividualPanRegex.test(fieldValue)) {
          return createError({
            message: 'invalid PAN',
            path,
          });
        }
        return true;
      }),
    emailId: yup
      .string()
      .nullable()
      .matches(emailRegex, 'invalid Email ID')
      .required('Email is required'),
  });
  const initialValues1: EValues = {
    pan: pan,
    emailId: emailId ?? '',
    dob: dob,
    kraStatus: kraStatus,
  };

  const handleSubmit1 = async (values: EValues) => {
    const { emailId } = values;
    // if (typeof digioResponse?.blockJourney === 'string' && digioResponse?.blockJourney === 'true') {
    //   const { destroy } = showModal(SimpleDialog, {
    //     content: 'Your KYC is currently on hold. Please contact support for further assistance.',
    //     actions: [
    //       {
    //         label: 'OK',
    //         onClick: () => {
    //           destroy();
    //         },
    //       },
    //     ],
    //   });
    //   return;
    // }
    const response = (await dispatch(
      SendEmail({ panVerificationToken, emailId, digioInfoId: digioId })
    )) as unknown as VerifyOtpResponseBody;
    const { applicantVerificationToken } = response || {};
    const res = (await dispatch(
      createApplication({ applicantVerificationToken })
    )) as unknown as ApplicationProps;
    history.push('/non-individual-application', { ...(res || {}) });
    // history.push('verify-documents', {
    //   applicantVerificationToken,
    // });
  };

  // ✅ Called when dialog form succeeds
  const handleKraDialogSuccess = async ({
    emailId,
    phone,
    digioId,
  }: {
    emailId: string;
    phone: string;
    digioId: string;
  }) => {
    const response = (await dispatch(
      SendDigio({ emailId, phone, digioId })
    )) as unknown as SendDigioResponse;
    setDigioResponse(response);
    setKraDetailsCaptured(true);
    setKraDialogOpen(false);
  };

  return (
    <>
      <Formik
        initialValues={initialValues1}
        validationSchema={validationSchema1}
        onSubmit={handleSubmit1}>
        {({ handleSubmit, setFieldValue }) => {
          useEffect(() => {
            if (digioResponse?.emailId) {
              setFieldValue('emailId', digioResponse.emailId);
            }
          }, [digioResponse?.emailId]);
          return (
            <Box
              sx={
                {
                  // pointerEvents:
                  //   kraDetailsCaptured &&
                  //   !['kraonhold', 'not_kyc', 'kraregistered'].includes(kraStatus) &&
                  //   !digioId
                  //     ? 'auto'
                  //     : 'none',
                  // opacity:
                  //   kraDetailsCaptured &&
                  //   !['kraonhold', 'not_kyc', 'kraregistered'].includes(kraStatus) &&
                  //   !digioId
                  //     ? 1
                  //     : 0.5,
                }
              }>
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <Box sx={{ position: 'relative' }}>
                  <Box sx={{ position: 'absolute', right: 0, top: 15 }}>
                    <CardMedia
                      component="img"
                      src="/images/tick.svg"
                      sx={{ width: '18px', float: 'right' }}
                    />
                  </Box>
                  <MFTextField
                    label="PAN"
                    name="pan"
                    placeholder="Enter PAN"
                    required
                    inputProps={{ style: { textTransform: 'uppercase' } }}
                    disabled={true}
                  />
                  {IS_DOB_APPLICABLE_FOR_AMC && (
                    <TextDatePicker
                      minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 125))}
                      label={'Date of Birth/Incorporation'}
                      inputLabelStyles={{
                        transform: 'unset',
                        fontSize: 14,
                        fontWeight: 500,
                        color: 'rgba(0,0,0,0.7)',
                      }}
                      placeholder={'Enter Date of birth'}
                      name="dob"
                      disabled={true}
                    />
                  )}
                </Box>
                <MFTextField
                  autoComplete="off"
                  autoFocus
                  label="Contact Person Email ID"
                  name="emailId"
                  placeholder="Enter Contact Person Email ID"
                  required
                />
                {kraStatus && (
                  <MFSelectField
                    name={`kraStatus`}
                    label="KRA Status *"
                    items={Object.keys(KRA_STATUS_MASTER).map((item) => ({
                      key: KRA_STATUS_MASTER[item],
                      value: item,
                    }))}
                    disabled={true}
                  />
                )}
                {digioResponse?.digioLink && (
                  <Stack
                    spacing={1}
                    sx={{
                      backgroundColor: 'rgba(51, 127, 201, 0.04)',
                      border: '1px solid rgba(51, 127, 201, 0.2)',
                      borderRadius: 2,
                      padding: 2,
                      boxSizing: 'border-box',
                    }}>
                    {/* Header */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between">
                      <Typography variant="subtitle2" fontWeight={600}>
                        KYC Completion Link (For Client)
                      </Typography>

                      <Stack direction="row" spacing={0.5}>
                        {/* Open Link */}
                        <Tooltip title="Open link in new tab">
                          <IconButton
                            size="small"
                            onClick={() => openUrl(digioResponse?.digioLink)}>
                            <OpenInNewIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>

                        {/* Copy Link */}
                        <Tooltip title="Copy link">
                          <IconButton
                            size="small"
                            onClick={() => navigator.clipboard.writeText(digioResponse?.digioLink)}>
                            <ContentCopyIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </Stack>

                    {/* URL Display */}
                    {digioResponse?.digioLink && (
                      <Tooltip title={digioResponse?.digioLink}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          sx={{
                            backgroundColor: '#fff',
                            border: '1px dashed',
                            borderColor: 'divider',
                            borderRadius: 1,
                            px: 1.5,
                            py: 1,
                            cursor: 'default',
                          }}>
                          <Typography
                            variant="body2"
                            sx={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              color: 'text.secondary',
                              width: '100%',
                            }}>
                            {digioResponse?.digioLink}
                          </Typography>
                        </Stack>
                      </Tooltip>
                    )}
                  </Stack>
                )}
                <Notes
                  displayContent={
                    'If the KYC is not validated for Resident Individual (RI) then request you to do the KYC validation at the earliest. Allotment shall be on hold for RI if KYC is not validated at the time of on-boarding'
                  }
                />
                <Notes
                  displayContent={
                    'Based on registered email id, we will fetch the documents available with our MF holding that are serviced by kfintech and the data will be prefilled in the application.'
                  }
                />
                <MFSubmitButton
                  label={'Proceed'}
                  disabled={digioResponse?.blockJourney === 'true'}
                />
              </Box>
            </Box>
          );
        }}
      </Formik>
      <KRAAlertDialog
        open={kraDialogOpen}
        initialEmail={pan ? undefined : ''}
        initialPhone={pan ? undefined : ''}
        digioId={digioId}
        onSuccess={handleKraDialogSuccess}
      />
    </>
  );
}
